/* Personalización propia – Camisetas Futbolero
   Sustituye a Globo Product Options. Camiseta + líneas de extras enlazadas por _cf_id / _cf_parent. */
(function () {
  'use strict';

  var CF = (window.CF = window.CF || {});
  var T = window.CF_I18N || {
    needName: 'Escribe un nombre o un dorsal, o desactiva la personalización.',
    max: 'Puedes añadir hasta 3 parches.', remove: 'Quitar', buyNow: 'Comprar ya',
    adding: 'Añadiendo…', shirt: 'Camiseta', persTitle: 'Nombre y dorsal', patchesTitle: 'Parches', total: 'Total',
    offerIn: 'Con esta camiseta ahorras un {d} % en todas (llevas {c} en el carrito)', offerNext: 'Llévate {k} más y ahorra un {d} %, combinando equipos'
  };
  /* letras de cualquier alfabeto latino (Ø, Ć, Ğ, Š…), espacio, punto, apóstrofo y guion */
  var NAME_BAD = (function () { try { return new RegExp('[^\\p{L}\' .\\-]', 'gu'); } catch (e) { return /[^A-ZÀ-ÖØ-ÞĀ-ž' .\-]/g; } })();
  var SHOWN_PROPS = ['Tallaje', 'Nombre', 'Dorsal', 'Parches', 'Otros parches'];

  /* ---------- utilidades ---------- */
  function money(cents, fmt) {
    fmt = fmt || CF.moneyFormat || window.CF_MONEY || window.money_format;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) return Shopify.formatMoney(cents, fmt);
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function post(url, data) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function props(it) { return (it && it.properties) || {}; }
  function isCartPage() { return /\/cart\/?$/.test(location.pathname); }

  CF.money = money;
  CF.getCart = getCart;

  /* ---------- descuento por cantidad (los porcentajes vienen de la tienda: custom.descuento_cantidad) ---------- */
  function parseTiers(s) {
    return String(s || '').split(',').map(function (x) { return x.split(':').map(Number); })
      .filter(function (a) { return a[0] > 1 && a[1] > 0 && a[1] < 100; })
      .sort(function (a, b) { return a[0] - b[0]; });
  }
  CF.tiers = parseTiers(window.CF_TIERS);
  function tierFor(n) { var d = 0; CF.tiers.forEach(function (t) { if (n >= t[0]) d = t[1]; }); return d; }
  function nextTier(n) { for (var i = 0; i < CF.tiers.length; i++) if (n < CF.tiers[i][0]) return CF.tiers[i]; return null; }
  function isShirt(it) { return !props(it)._cf_parent && !/^(extra-|option-set-)/.test(it.handle || ''); }
  CF.shirtCount = function (cart) { return (cart.items || []).reduce(function (s, it) { return s + (isShirt(it) ? it.quantity : 0); }, 0); };
  function fmtT(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }

  CF.tierBarHtml = function (cart) {
    if (!CF.tiers.length) return '';
    var L = window.CF_TIER_I18N || { next: 'Añade {k} camiseta{s} más y ahorras {e} (−{d} % en todas)', got: '¡Ahorras un {d} % en tus camisetas!', gotNext: '¡Ahorras un {d} %! Añade {k} más y ahorra un {d2} %', saved: 'Ahorro aplicado' };
    var n = CF.shirtCount(cart);
    if (!n) return '';
    var d = tierFor(n), nx = nextTier(n), msg;
    var shirtsTotal = (cart.items || []).reduce(function (s, it) { return s + (isShirt(it) ? it.original_line_price || it.line_price || it.final_line_price || 0 : 0); }, 0);
    var avg = n ? shirtsTotal / n : 0;
    var eur = function (k, pct) { return money(Math.round(avg * (n + k) * pct / 100)); };
    if (!d && nx) msg = fmtT(L.next, { k: nx[0] - n, s: nx[0] - n > 1 ? 's' : '', d: nx[1], e: eur(nx[0] - n, nx[1]) });
    else if (d && nx) msg = fmtT(L.gotNext, { d: d, k: nx[0] - n, d2: nx[1], e: eur(nx[0] - n, nx[1]) });
    else msg = fmtT(L.got, { d: d });
    var top = CF.tiers[CF.tiers.length - 1][0];
    var pct = Math.min(100, Math.round(100 * n / top));
    var steps = CF.tiers.map(function (t) {
      return '<span class="cf-tierbar__step' + (n >= t[0] ? ' is-on' : '') + '" style="left:' + Math.round(100 * t[0] / top) + '%">-' + t[1] + '%</span>';
    }).join('');
    var saved = cart.total_discount > 0 ? '<div class="cf-tierbar__saved">' + esc(L.saved) + ': <strong>-' + money(cart.total_discount, window.money_format) + '</strong></div>' : '';
    return '<div class="cf-tierbar' + (nx ? '' : ' is-max') + '"><div class="cf-tierbar__msg">' + esc(msg) + '</div>' +
      '<div class="cf-tierbar__track"><span class="cf-tierbar__fill" style="width:' + pct + '%"></span>' + steps + '</div>' + saved + '</div>';
  };
  function placeTierBar(cart) {
    var $ = window.jQuery; if (!$) return;
    $('.cf-tierbar').remove();
    var html = CF.tierBarHtml(cart);
    if (!html) return;
    var loop = $('.ltn__utilize-cart-menu .cart-item-loop').first();
    if (!loop.length) loop = $('.cart-item-loop').first();
    if (loop.length) loop.before(html);
    var table = $('.cart-page .cart-table').first();
    if (table.length) table.before(html);
  }
  CF.placeTierBar = placeTierBar;

  /* ---------- carrito: sincronía de extras ---------- */
  CF.computeUpdates = function (cart) {
    var parents = {}, updates = {}, n = 0;
    (cart.items || []).forEach(function (it) {
      var id = props(it)._cf_id;
      if (id) parents[id] = (parents[id] || 0) + it.quantity;
    });
    (cart.items || []).forEach(function (it) {
      var p = props(it);
      if (!p._cf_parent) return;
      var unit = parseInt(p._cf_unit, 10) || 1;
      var expected = (parents[p._cf_parent] || 0) * unit;
      if (expected !== it.quantity) { updates[it.key] = expected; n++; }
    });
    return n ? updates : null;
  };

  CF.sync = function (cart) {
    var u = CF.computeUpdates(cart);
    if (!u) return Promise.resolve({ cart: cart, changed: false });
    return post('/cart/update.js', { updates: u }).then(function (c) { return { cart: c, changed: true }; });
  };

  CF.count = function (cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var p = props(it);
      if (!p._cf_parent || !hasParent(cart, p._cf_parent)) n += it.quantity;
    });
    return n;
  };

  function hasParent(cart, id) {
    return (cart.items || []).some(function (x) { return props(x)._cf_id === id; });
  }

  CF.afterCartChange = function (cart) {
    if (isCartPage()) { location.reload(); return; }
    if (window.Shopify && typeof Shopify.cartUpdateInfo === 'function') Shopify.cartUpdateInfo(cart, '.cart-item-loop');
  };

  CF.removeLine = function (key) {
    return getCart().then(function (cart) {
      var u = {}; u[key] = 0;
      var it = (cart.items || []).filter(function (x) { return x.key === key; })[0];
      var id = it && props(it)._cf_id;
      if (id) (cart.items || []).forEach(function (x) { if (props(x)._cf_parent === id) u[x.key] = 0; });
      return post('/cart/update.js', { updates: u });
    }).then(CF.afterCartChange);
  };

  CF.addItems = function (items) {
    return post('/cart/add.js', { items: items });
  };

  /* ---------- cajón del carrito (sobrescribe cart.api.js del tema) ---------- */
  function lineMeta(p) {
    var out = [];
    SHOWN_PROPS.forEach(function (k) { if (p[k]) out.push('<span class="cf-mc__meta">' + esc(k) + ': ' + esc(p[k]) + '</span>'); });
    return out.join('');
  }

  function renderDrawer(cart, cellSel) {
    var fmt = window.CF_MONEY || window.money_format;
    var $ = window.jQuery;
    if (!$) return;
    var cell = $(cellSel || '.cart-item-loop');
    var items = cart.items || [];
    var kids = {};
    items.forEach(function (it) {
      var pid = props(it)._cf_parent;
      if (pid && hasParent(cart, pid)) (kids[pid] = kids[pid] || []).push(it);
    });
    if (cell.length) {
      cell.empty();
      if (!items.length) {
        $('.cart-item-display').css({ display: 'none' });
        $('.cart-empty-title').css({ display: 'block' });
      } else {
        $('.cart-item-display').css({ display: 'block' });
        $('.cart-empty-title').css({ display: 'none' });
        var shown = 0;
        items.forEach(function (item) {
          var p = props(item);
          if (p._cf_parent && hasParent(cart, p._cf_parent)) return;
          if (shown++ > 19) return;
          var extras = kids[p._cf_id] || [];
          var extrasHtml = extras.map(function (x) {
            return '<li>+ ' + esc(x.product_title) + ' <span>' + money(x.final_line_price, fmt) + '</span></li>';
          }).join('');
          var lineTotal = item.final_line_price + extras.reduce(function (s, x) { return s + x.final_line_price; }, 0);
          var variant = item.variant_title && item.variant_title.indexOf('Default') === -1 ? ' · ' + esc(item.variant_title) : '';
          $('<div class="mini-cart-item clearfix">' +
              '<div class="mini-cart-img"><a href="' + esc(item.url) + '"><img src="' + esc(item.image || '') + '" style="width:100px" alt=""></a>' +
              '<span onclick="CF.removeLine(\'' + esc(item.key) + '\')" class="mini-cart-item-delete" role="button" aria-label="' + esc(T.remove) + '"><i class="icon-cancel"></i></span></div>' +
              '<div class="mini-cart-info"><h6><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h6>' +
              (variant ? '<span class="cf-mc__meta">' + variant.replace(' · ', '') + '</span>' : '') +
              lineMeta(p) +
              (extrasHtml ? '<ul class="cf-mc__extras">' + extrasHtml + '</ul>' : '') +
              '<span class="mini-cart-quantity">' + item.quantity + ' x ' + money(item.final_price, fmt) +
              (extras.length ? ' · <strong>' + money(lineTotal, fmt) + '</strong>' : '') + '</span>' +
              '</div></div>').appendTo(cell);
        });
      }
    }
    $('.shopping-cart__total').html(money(cart.total_price, fmt));
    $('.bigcounter').html(CF.count(cart));
    window.CF_COUNT = CF.shirtCount(cart);
    placeTierBar(cart);
    placeUpsell(cart);
    $('.currency .active').trigger('click');
  }


  /* ---------- cajón: "Completa tu pack" (otras camisetas, con talla y nombre/dorsal) ---------- */
  var recCache = {};
  function isKidsP(p) { return (p.tags || []).some(function (t) { return /^(niños|ninos|niño|kids)$/i.test(t); }); }
  function isExtraP(p) {
    return /^(extra-|option-set-)/.test(p.handle || '') || (p.tags || []).some(function (t) { return /extra-personalizacion|globo-product-options|sin-personalizacion/.test(t); });
  }
  function recsFor(pid) {
    if (recCache[pid]) return recCache[pid];
    recCache[pid] = fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
    return recCache[pid];
  }
  function img(src, w) {
    if (!src) return '';
    src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }
  function upsellHtml(list, cart) {
    var U = window.CF_UP_I18N || {};
    var n = CF.shirtCount(cart), d = tierFor(n + 1), nx = nextTier(n);
    var sub = nx ? fmtT(U.sub, { d: nx[1] }) : fmtT(U.subMax, { d: d });
    var nd = window.CF_ND;
    var cards = list.map(function (p) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) return '';
      var price = vs[0].price, now = Math.round(price * (100 - d) / 100);
      var opts = vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('');
      var kids = isKidsP(p);
      return '<div class="cf-up__item" data-cf-up-item data-title="' + esc(p.title) + '">' +
        '<a class="cf-up__img" href="' + esc(p.url || ('/products/' + p.handle)) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt="" loading="lazy" width="80" height="80"></a>' +
        '<div class="cf-up__body"><a class="cf-up__name" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
        '<div class="cf-up__price">' + (d ? '<s>' + money(price) + '</s> ' : '') + '<strong>' + money(now) + '</strong></div>' +
        '<div class="cf-up__row"><select class="cf-up__sel" data-cf-up-size aria-label="' + esc(U.size) + '"><option value="">' + esc(U.size) + '</option>' + opts + '</select>' +
        (kids ? '' : '<select class="cf-up__sel cf-up__sel--fit" data-cf-up-fit aria-label="Tallaje"><option>' + esc(U.men) + '</option><option>' + esc(U.women) + '</option></select>') + '</div>' +
        (nd ? '<button type="button" class="cf-up__pers needsclick" data-cf-up-pers>' + esc(U.pers) + ' <span>+' + money(nd.price) + '</span></button>' +
          '<div class="cf-up__persf" data-cf-up-persf hidden><input type="text" maxlength="14" autocomplete="off" autocapitalize="characters" placeholder="' + esc(U.name) + '" data-cf-up-name>' +
          '<input type="text" inputmode="numeric" maxlength="2" autocomplete="off" placeholder="' + esc(U.num) + '" data-cf-up-num></div>' : '') +
        (window.CF_PA ? '<button type="button" class="cf-up__pers needsclick" data-cf-up-ptog data-handle="' + esc(p.handle) + '">' + esc(U.patches) + ' <span>+' + money(window.CF_PA.price) + ' ' + esc(U.patchEach) + '</span></button>' +
          '<div class="cf-up__patches" data-cf-up-patches hidden></div>' : '') +
        '<button type="button" class="cf-up__add needsclick" data-cf-up-add>' + esc(U.add) + '</button>' +
        '<div class="cf-up__err" data-cf-up-err hidden></div></div></div>';
    }).filter(Boolean);
    if (!cards.length) return '';
    return '<div class="cf-up" data-cf-up><div class="cf-up__head"><strong>' + esc(U.title) + '</strong><span>' + esc(sub) + '</span></div>' +
      '<div class="cf-up__list">' + cards.slice(0, 4).join('') + '</div></div>';
  }
  function placeUpsell(cart) {
    var $ = window.jQuery; if (!$) return;
    var drawer = $('.ltn__utilize-cart-menu');
    if (!drawer.length || !CF.tiers.length || !window.CF_UP_I18N) { $('.cf-up').remove(); return; }
    var shirts = (cart.items || []).filter(isShirt);
    if (!shirts.length) { $('.cf-up').remove(); return; }
    var inCartIds = {}; (cart.items || []).forEach(function (it) { inCartIds[it.product_id] = 1; });
    var last = shirts[0]; /* cart.items llega con lo último añadido primero */
    recsFor(last.product_id).then(function (list) {
      list = list.filter(function (p) { return !inCartIds[p.id] && !isExtraP(p); });
      drawer.find('.cf-up').remove();
      var html = upsellHtml(list, cart);
      if (!html) return;
      var loop = drawer.find('.cart-item-loop').first();
      if (loop.length) loop.after(html);
    });
  }
  CF.placeUpsell = placeUpsell;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var pers = t.closest && t.closest('[data-cf-up-pers]');
    if (pers) {
      var f = pers.parentNode.querySelector('[data-cf-up-persf]');
      f.hidden = !f.hidden; pers.classList.toggle('is-on', !f.hidden);
      if (!f.hidden) { var ni = f.querySelector('input'); setTimeout(function () { ni.focus(); }, 50); }
      return;
    }
    var ptog = t.closest && t.closest('[data-cf-up-ptog]');
    if (ptog) {
      var box = ptog.parentNode.querySelector('[data-cf-up-patches]');
      box.hidden = !box.hidden; ptog.classList.toggle('is-on', !box.hidden);
      if (!box.hidden && !box.dataset.loaded) {
        box.dataset.loaded = '1';
        var U2 = window.CF_UP_I18N || {};
        fetch('/products/' + encodeURIComponent(ptog.dataset.handle) + '?view=cfdata', { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (txt) { try { return JSON.parse(txt).patches || []; } catch (e) { return []; } })
          .catch(function () { return []; })
          .then(function (list) {
            list.sort(function (a, b) { return (+a.o || 99) - (+b.o || 99); });
            box.innerHTML = list.map(function (pt) {
              return '<button type="button" class="cf-up__chip needsclick" data-cf-up-patch="' + esc(pt.n) + '" aria-pressed="false">' +
                (pt.img ? '<img src="' + esc(pt.img) + '" alt="" width="22" height="22" loading="lazy">' : '') + esc(pt.n) + '</button>';
            }).join('') + '<input type="text" maxlength="40" autocomplete="off" placeholder="' + esc(U2.other) + '" data-cf-up-other>';
          });
      }
      return;
    }
    var chip = t.closest && t.closest('[data-cf-up-patch]');
    if (chip) {
      var wrap = chip.parentNode, on = chip.getAttribute('aria-pressed') !== 'true';
      var oth = wrap.querySelector('[data-cf-up-other]');
      var used = wrap.querySelectorAll('[data-cf-up-patch][aria-pressed="true"]').length + (oth && oth.value.trim() ? 1 : 0);
      var errB = wrap.parentNode.querySelector('[data-cf-up-err]');
      if (on && used >= 3) { errB.textContent = (window.CF_UP_I18N || {}).maxP; errB.hidden = false; return; }
      errB.hidden = true;
      chip.setAttribute('aria-pressed', on ? 'true' : 'false'); chip.classList.toggle('is-on', on);
      return;
    }
    var add = t.closest && t.closest('[data-cf-up-add]');
    if (!add || add.disabled) return;
    var U = window.CF_UP_I18N || {};
    var card = add.closest('[data-cf-up-item]');
    var sel = card.querySelector('[data-cf-up-size]'), fit = card.querySelector('[data-cf-up-fit]');
    var err = card.querySelector('[data-cf-up-err]');
    err.hidden = true;
    if (!sel.value) { sel.classList.add('is-err'); sel.focus(); return; }
    var nm = card.querySelector('[data-cf-up-name]'), nu = card.querySelector('[data-cf-up-num]');
    var pf = card.querySelector('[data-cf-up-persf]');
    var name = nm && !pf.hidden ? nm.value.trim().toUpperCase() : '', num = nu && !pf.hidden ? nu.value.replace(/\D/g, '') : '';
    var vtitle = sel.options[sel.selectedIndex].text;
    var p = {};
    if (fit) p.Tallaje = fit.value;
    var items = [{ id: +sel.value, quantity: 1, properties: p }];
    var pbox = card.querySelector('[data-cf-up-patches]');
    var chosen = pbox && !pbox.hidden ? Array.prototype.map.call(pbox.querySelectorAll('[data-cf-up-patch][aria-pressed="true"]'), function (b) { return b.dataset.cfUpPatch; }) : [];
    var otherIn2 = pbox && !pbox.hidden && pbox.querySelector('[data-cf-up-other]');
    var other = otherIn2 ? otherIn2.value.trim() : '';
    if (chosen.length + (other ? 1 : 0) > 3) { err.textContent = U.maxP; err.hidden = false; return; }
    var id = uid();
    if (chosen.length || other) {
      if (chosen.length) p.Parches = chosen.join(', ');
      if (other) p['Otros parches'] = other;
      var allP = chosen.concat(other ? [other] : []);
      p._cf_id = id;
      if (window.CF_PA) items.push({ id: window.CF_PA.id, quantity: allP.length, properties: { Camiseta: card.dataset.title + ' · ' + vtitle, Parches: allP.join(', '), _cf_parent: id, _cf_unit: String(allP.length) } });
    }
    if ((name || num) && window.CF_ND) {
      if (name) p.Nombre = name; if (num) p.Dorsal = num; p._cf_id = id;
      items.splice(1, 0, { id: window.CF_ND.id, quantity: 1, properties: { Camiseta: card.dataset.title + ' · ' + vtitle, 'Personalización': [name, num].filter(Boolean).join(' '), _cf_parent: id, _cf_unit: '1' } });
    }
    add.disabled = true; add.textContent = U.adding;
    CF.addItems(items).then(getCart).then(function (cart) {
      add.textContent = U.added;
      window.CF_COUNT = CF.shirtCount(cart);
      if (CF.refresh) CF.refresh();
      renderDrawer(cart, '.cart-item-loop');
    }).catch(function () {
      add.disabled = false; add.textContent = U.add; err.textContent = U.err; err.hidden = false;
    });
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cf-up-size]')) e.target.classList.remove('is-err');
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-cf-up-name]')) { var v = t.value.toUpperCase().replace(NAME_BAD, ''); if (v !== t.value) t.value = v; }
    if (t.matches && t.matches('[data-cf-up-num]')) { var w = t.value.replace(/\D/g, '').slice(0, 2); if (w !== t.value) t.value = w; }
  });

  function patchThemeCart() {
    if (!window.Shopify) return;
    Shopify.cartUpdateInfo = renderDrawer;
    Shopify.onCartUpdate = function (cart) {
      CF.sync(cart).then(function (r) { renderDrawer(r.cart, '.cart-item-loop'); });
    };
  }

  /* ---------- ficha de producto ---------- */
  function initProduct() {
    var root = document.getElementById('cf-personalizacion');
    if (!root) return;
    var form = root.closest('form') || document.getElementById('AddToCartForm');
    if (!form) return;

    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-cf-variants]').textContent); } catch (e) {}
    var ND = { id: +root.dataset.ndVariant, price: +root.dataset.ndPrice };
    var PA = { id: +root.dataset.paVariant, price: +root.dataset.paPrice };
    var MAX = +root.dataset.maxPatches || 3;
    var KIDS = root.dataset.kids === 'true';
    CF.moneyFormat = root.dataset.moneyFormat || window.money_format;

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var toggle = q('[data-cf-toggle]'), pers = q('[data-cf-pers]');
    var nameIn = q('[data-cf-name]'), numIn = q('[data-cf-num]');
    var otherIn = q('[data-cf-other]'), otherAdd = q('[data-cf-other-add]'), chips = q('[data-cf-chips]');
    var errEl = q('[data-cf-error]'), fitInput = q('[data-cf-fit-input]');
    var state = { fit: KIDS ? null : 'Hombre', patches: [], others: [] };

    /* orden de parches */
    var patchWrap = q('[data-cf-patches]');
    qa('[data-cf-patch]').sort(function (a, b) { return (+a.dataset.order || 99) - (+b.dataset.order || 99); })
      .forEach(function (b) { patchWrap.appendChild(b); });
    if (!patchWrap.children.length) patchWrap.hidden = true;

    function setErr(msg, focusEl) {
      errEl.textContent = msg || '';
      root.classList.toggle('cf--error', !!msg);
      if (msg && focusEl) {
        var card = focusEl.closest('.cf__card') || root;
        card.classList.add('cf__card--shake');
        setTimeout(function () { card.classList.remove('cf__card--shake'); }, 450);
        try { focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 300);
      }
    }
    function persErr(msg) {
      var el = pers.querySelector('.cf__error');
      if (!el) { el = document.createElement('p'); el.className = 'cf__error'; el.setAttribute('role', 'alert'); pers.insertBefore(el, pers.querySelector('.cf__preview')); }
      el.textContent = msg || '';
    }

    /* tallaje */
    qa('[data-cf-fit]').forEach(function (b) {
      b.addEventListener('click', function () {
        qa('[data-cf-fit]').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
        state.fit = b.dataset.cfFit;
        if (fitInput) fitInput.value = state.fit;
      });
    });

    /* guía de tallas (reutiliza el botón que ya tienes en la ficha) */
    var sgBtn = q('[data-cf-sizeguide]'), sgOrig = document.getElementById('sg-open-btn');
    if (sgBtn && sgOrig) { sgBtn.hidden = false; sgBtn.addEventListener('click', function () { sgOrig.click(); }); }

    /* nombre y dorsal */
    function name() { return (nameIn.value || '').trim().toUpperCase(); }
    function num() { return (numIn.value || '').replace(/\D/g, ''); }
    function isOn() { return toggle.getAttribute('aria-checked') === 'true'; }
    function persActive() { return isOn() && (name() || num()); }
    function updPreview() {
      root.classList.toggle('cf--typed', !!(name() || num()));
    }
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var on = !isOn();
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      pers.hidden = !on;
      root.classList.toggle('cf--pers', on);
      persErr('');
      /* foco dentro del mismo toque para que el móvil abra el teclado */
      if (on) { try { nameIn.focus({ preventScroll: true }); } catch (err) {} }
      refresh();
    });
    nameIn.addEventListener('input', function () {
      var pos = nameIn.selectionStart;
      nameIn.value = nameIn.value.toUpperCase().replace(NAME_BAD, '');
      try { nameIn.setSelectionRange(pos, pos); } catch (e) {}
      persErr(''); updPreview(); refresh();
    });
    numIn.addEventListener('input', function () {
      numIn.value = numIn.value.replace(/\D/g, '').slice(0, 2);
      persErr(''); updPreview(); refresh();
    });
    qa('[data-cf-suggest]').forEach(function (b) {
      b.addEventListener('click', function () {
        nameIn.value = b.dataset.name || ''; numIn.value = b.dataset.num || '';
        persErr(''); updPreview(); refresh();
      });
    });

    /* parches (plegables) */
    var ptoggle = q('[data-cf-ptoggle]'), ppanel = q('[data-cf-ppanel]');
    function total() { return state.patches.length + state.others.length; }
    if (ptoggle) ptoggle.addEventListener('click', function (e) {
      e.preventDefault();
      var on = ptoggle.getAttribute('aria-checked') !== 'true';
      ptoggle.setAttribute('aria-checked', on ? 'true' : 'false');
      ppanel.hidden = !on;
      root.classList.toggle('cf--patch', on);
      if (!on) {
        state.patches = []; state.others = []; otherIn.value = '';
        qa('[data-cf-patch]').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
        renderChips(); setErr('');
      }
      refresh();
    });
    qa('[data-cf-patch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.dataset.cfPatch, i = state.patches.indexOf(n);
        if (i > -1) { state.patches.splice(i, 1); b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); setErr(''); }
        else {
          if (total() + pendingOther() >= MAX) { setErr(T.max); return; }
          state.patches.push(n); b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); setErr('');
        }
        refresh();
      });
    });
    function renderChips() {
      chips.innerHTML = state.others.map(function (o, i) {
        return '<span class="cf__chip">' + esc(o) + '<button type="button" data-i="' + i + '" aria-label="' + esc(T.remove) + ' ' + esc(o) + '">×</button></span>';
      }).join('');
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]');
      if (!b) return;
      state.others.splice(+b.dataset.i, 1); renderChips(); setErr(''); refresh();
    });
    function addOther() {
      var v = (otherIn.value || '').trim().replace(/\s+/g, ' ');
      if (!v) return true;
      if (total() >= MAX) { setErr(T.max, otherIn); return false; }
      if (state.others.indexOf(v) === -1) state.others.push(v);
      otherIn.value = ''; renderChips(); setErr(''); refresh();
      return true;
    }
    otherAdd.addEventListener('click', addOther);
    otherIn.addEventListener('input', refresh);

    /* que Enter no envíe el formulario */
    [nameIn, numIn, otherIn].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (el === otherIn) addOther(); else el.blur();
      });
    });

    /* variante y cantidad */
    function vid() { var s = form.querySelector('[name="id"]'); return s ? s.value : null; }
    function qty() { var s = form.querySelector('[name="quantity"]'); var n = parseInt(s && s.value, 10); return n > 0 ? n : 1; }
    function pendingOther() { return (otherIn.value || '').trim() ? 1 : 0; }
    function extrasPerShirt() {
      var c = 0;
      if (persActive()) c += ND.price;
      c += (total() + (total() < MAX ? pendingOther() : 0)) * PA.price;
      return c;
    }
    function hasExtras() { return !!persActive() || total() > 0 || pendingOther() > 0; }

    var sticky = document.querySelector('.product-addtocart-sticky');
    var stickyBtn = sticky && sticky.querySelector('button[type="submit"], [type="submit"]');
    var stickyLabel = stickyBtn ? stickyBtn.textContent.trim() : '';
    /* precio total en el botón */
    var atc = form.querySelector('#AddToCart');
    var totalSpan = null;
    if (atc) {
      var label = atc.querySelector('#AddToCartText');
      totalSpan = document.createElement('span');
      totalSpan.className = 'cf-atc-total';
      if (label && label.parentNode) label.parentNode.insertBefore(totalSpan, label.nextSibling);
    }
    var summary = q('[data-cf-summary]');

    /* aviso de descuento por cantidad (una línea) */
    var offerText = q('[data-cf-offer-text]');
    var offerDefault = offerText ? offerText.textContent : '';
    function inCart() { return typeof window.CF_COUNT === 'number' ? window.CF_COUNT : 0; }
    function renderOffer() {
      if (!offerText || !CF.tiers.length) return;
      var c = inCart(), dNow = tierFor(c + qty()), nx = nextTier(c + qty());
      if (c > 0 && dNow) offerText.textContent = fmtT(T.offerIn, { d: dNow, c: c });
      else if (c > 0 && nx) offerText.textContent = fmtT(T.offerNext, { k: nx[0] - c - qty(), d: nx[1] });
      else offerText.textContent = offerDefault;
    }

    function refresh() {
      var v = variants[vid()] || {};
      var base = v.price || 0;
      var extra = extrasPerShirt();
      var n = qty();
      if (totalSpan) {
        var disabled = atc.disabled || atc.classList.contains('disabled') || v.available === false;
        var dPct = tierFor(n + inCart());
        var full = (base + extra) * n, now = Math.round(base * (100 - dPct) / 100 + extra) * n;
        totalSpan.innerHTML = disabled ? '' : (dPct ? '<s>' + money(full) + '</s> ' : '') + money(now);
        if (stickyBtn) stickyBtn.innerHTML = esc(stickyLabel) + (disabled ? '' : ' · ' + (dPct ? '<s>' + money(full) + '</s> ' : '') + money(now));
      }
      if (summary) {
        if (extra > 0) {
          var bits = [];
          if (persActive()) bits.push(esc(T.persTitle) + ' +' + money(ND.price));
          var pc = total() + (total() < MAX ? pendingOther() : 0);
          if (pc) bits.push(pc + ' × ' + esc(pc === 1 ? (T.patchOne || 'parche') : T.patchesTitle.toLowerCase()) + ' +' + money(pc * PA.price));
          summary.innerHTML = '<span>' + esc(T.shirt) + ' ' + money(base) + '</span><span>' + bits.join('</span><span>') +
            '</span><strong>' + esc(T.total) + ': ' + money(base + extra) + (n > 1 ? ' × ' + n : '') + '</strong>';
          summary.hidden = false;
        } else summary.hidden = true;
      }
      renderOffer();
      toggleBuyNow();
    }
    CF.refresh = refresh;

    form.addEventListener('change', function () { setTimeout(refresh, 60); });
    form.addEventListener('click', function (e) {
      if (e.target.closest('.swatch, .swatch-element, .qtybutton, .cart-plus-minus')) setTimeout(refresh, 80);
    });
    form.addEventListener('input', function (e) { if (e.target.name === 'quantity') refresh(); });

    /* validación */
    function validate() {
      persErr(''); setErr('');
      if (isOn() && !name() && !num()) {
        persErr(T.needName);
        var card = nameIn.closest('.cf__card');
        card.classList.add('cf__card--shake');
        setTimeout(function () { card.classList.remove('cf__card--shake'); }, 450);
        try { nameIn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        setTimeout(function () { nameIn.focus({ preventScroll: true }); }, 300);
        return false;
      }
      if (!addOther()) return false;
      return true;
    }

    /* construir las líneas del carrito */
    function build(variantId, n) {
      var v = variants[variantId] || {};
      var shirt = root.dataset.title + (v.title && v.title.indexOf('Default') === -1 ? ' · ' + v.title : '');
      var id = uid();
      var p = {};
      if (state.fit) p.Tallaje = state.fit;
      var withPers = !!persActive();
      if (withPers) { if (name()) p.Nombre = name(); if (num()) p.Dorsal = num(); }
      if (state.patches.length) p.Parches = state.patches.join(', ');
      if (state.others.length) p['Otros parches'] = state.others.join(', ');
      var allPatches = state.patches.concat(state.others);
      if (withPers || allPatches.length) p._cf_id = id;
      var items = [{ id: +variantId, quantity: n, properties: p }];
      if (withPers) items.push({ id: ND.id, quantity: n, properties: { Camiseta: shirt, 'Personalización': [name(), num()].filter(Boolean).join(' '), _cf_parent: id, _cf_unit: '1' } });
      if (allPatches.length) items.push({ id: PA.id, quantity: n * allPatches.length, properties: { Camiseta: shirt, Parches: allPatches.join(', '), _cf_parent: id, _cf_unit: String(allPatches.length) } });
      return items;
    }

    function resetAfterAdd() {
      /* deja todo como estaba por si quiere otra; solo limpia el texto libre pendiente */
      otherIn.value = '';
      refresh();
    }

    /* validar antes de que el tema abra el cajón */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#AddToCart');
      if (!b || !form.contains(b)) return;
      if (!validate()) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
    }, true);

    /* el tema llama a Shopify.addItemFromFormStart('AddToCartForm', ...) */
    if (window.Shopify) {
      var origStart = Shopify.addItemFromFormStart;
      Shopify.addItemFromFormStart = function (formId) {
        /* ojo: form.id devolvería el <select name="id"> del formulario, por eso getAttribute */
        if (formId !== form.getAttribute('id')) return origStart && origStart.apply(this, arguments);
        var items = build(vid(), qty());
        CF.addItems(items).then(function () {
          window.CF_COUNT = inCart() + qty();
          resetAfterAdd();
          if (typeof Shopify.onItemAdded === 'function') Shopify.onItemAdded(); else getCart().then(renderDrawer);
        }).catch(function (err) {
          if (typeof Shopify.onError === 'function') Shopify.onError({ responseText: JSON.stringify(err || {}) });
        });
      };
    }

    /* si el formulario se envía de forma nativa, que pase por el mismo flujo */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc) atc.click();
    });

    /* Pago rápido: con personalización se oculta (el cliente revisa nombre y dorsal en el carrito
       y ve allí las ofertas); sin personalización se mantiene el de Shopify */
    function toggleBuyNow() {
      var pay = form.querySelector('.shopify-payment-button');
      if (!pay) return;
      var x = hasExtras();
      pay.style.display = x ? 'none' : '';
      var li = pay.closest('li');
      if (li) li.classList.toggle('cf-pay-hidden', x);
    }

    /* barra fija inferior del tema: que también lleve la personalización */
    if (sticky && atc) {
      sticky.classList.add('cf-sticky');
      var ss = sticky.querySelector('[name="id"]'), ms = form.querySelector('[name="id"]');
      if (ss) {
        Array.prototype.forEach.call(ss.options, function (o) { o.textContent = o.textContent.split(' - ')[0].trim(); });
        if (ms) ss.value = ms.value;
        ss.addEventListener('change', function () {
          if (!ms) return;
          ms.value = ss.value;
          try { ms.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
          if (window.jQuery) window.jQuery(ms).trigger('change');
          setTimeout(refresh, 60);
        });
        form.addEventListener('change', function () { if (ms && ss.value !== ms.value) ss.value = ms.value; });
      }
      sticky.addEventListener('submit', function (e) {
        e.preventDefault();
        var sv = sticky.querySelector('[name="id"]'), sq = sticky.querySelector('[name="quantity"]');
        var mv = form.querySelector('[name="id"]'), mq = form.querySelector('[name="quantity"]');
        if (sv && mv && sv.value) mv.value = sv.value;
        if (sq && mq) mq.value = sq.value;
        if (!validate()) return;
        atc.click();
      });
    }

    updPreview();
    refresh();
    /* la pasarela de pago rápido se pinta tarde */
    var tries = 0, t = setInterval(function () { toggleBuyNow(); if (++tries > 20) clearInterval(t); }, 300);
  }

  /* ---------- página de carrito ---------- */
  function initCartPage() {
    if (!isCartPage()) return;
    getCart().then(CF.sync).then(function (r) {
      if (r.changed) { location.reload(); return; }
      decorateCartPage(r.cart);
    });
  }

  /* agrupa visualmente los extras bajo su camiseta en /cart (las filas siguen el orden de cart.items) */
  function decorateCartPage(cart) {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.cart-table tbody > tr'));
    if (!rows.length || rows.length !== (cart.items || []).length) return;
    var rowById = {};
    /* pasamos updates[] a updates[clave] para poder mover filas sin descuadrar cantidades */
    cart.items.forEach(function (it, i) {
      var inp = rows[i].querySelector('input[name="updates[]"]');
      if (inp) inp.name = 'updates[' + it.key + ']';
      var id = props(it)._cf_id; if (id) rowById[id] = rows[i];
    });
    cart.items.forEach(function (it, i) {
      var row = rows[i], p = props(it);
      var parentRow = p._cf_parent && rowById[p._cf_parent];
      if (parentRow) {
        row.classList.add('cf-child-row');
        var qtyCell = row.querySelector('.pro-quantity');
        if (qtyCell) {
          var inp = qtyCell.querySelector('input');
          qtyCell.querySelectorAll('.qtybutton').forEach(function (b) { b.style.display = 'none'; });
          if (inp) { inp.readOnly = true; inp.setAttribute('aria-readonly', 'true'); }
        }
        var rm = row.querySelector('.pro-remove');
        if (rm) rm.innerHTML = '';
        var thumb = row.querySelector('.pro-thumbnail');
        if (thumb) thumb.innerHTML = '<span class="cf-child-plus">+</span>';
        parentRow.parentNode.insertBefore(row, parentRow.nextSibling);
        rowById[p._cf_parent] = row; /* mantiene el orden de los extras */
      } else if (p._cf_id) {
        var a = row.querySelector('.pro-remove a');
        if (a) a.addEventListener('click', function (e) { e.preventDefault(); CF.removeLine(it.key); });
      }
    });
  }

  function init() {
    patchThemeCart();
    if (CF.tiers.length && window.CF_COUNT > 0) getCart().then(function (c) { placeTierBar(c); placeUpsell(c); });
    if (typeof window.CF_COUNT === 'number' && window.jQuery) window.jQuery('.bigcounter').html(window.CF_COUNT);
    initProduct();
    initCartPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
